import { Route, Routes } from "react-router-dom";

import { Layout } from "./components/Layout";
import { Accueil } from "./pages/Accueil";
import { AuthentificationPage } from "./pages/AuthentificationPage";
import { CataloguePage } from "./pages/CataloguePage";
import { EspacePage } from "./pages/EspacePage";
import { ImportsPage } from "./pages/ImportsPage";
import { InvitationPage } from "./pages/InvitationPage";
import { ProductionPage } from "./pages/ProductionPage";
import { ResultatsPage } from "./pages/ResultatsPage";

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/catalogue" element={<CataloguePage />} />
        <Route path="/productions/:id" element={<ProductionPage />} />
        <Route path="/productions/:id/resultats" element={<ResultatsPage />} />
        <Route path="/connexion" element={<AuthentificationPage mode="connexion" />} />
        <Route path="/inscription" element={<AuthentificationPage mode="inscription" />} />
        <Route path="/espace" element={<EspacePage />} />
        <Route path="/imports" element={<ImportsPage />} />
        <Route path="/invitations/:jeton" element={<InvitationPage />} />
        <Route
          path="*"
          element={
            <section className="page">
              <div className="etat-vide">
                <strong>Cette page n’existe pas.</strong>
                <a href="/">Revenir à l’accueil</a>
              </div>
            </section>
          }
        />
      </Routes>
    </Layout>
  );
}
